module.exports = __webpack_public_path__ + "static/media/fear-reading.3cb616a2.jpg";